// LLM generated - Model Claude 4 Sonnet

import useStyles from './HomeIndicator.styles';

function HomeIndicator() {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.indicator} />
    </div>
  );
}

export default HomeIndicator;
